import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Typography, useTheme } from "@mui/material";
const EmptyArea = (param)=>{
    let { text  } = param;
    const theme = useTheme();
    return /*#__PURE__*/ _jsx(Box, {
        sx: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            minHeight: "260px",
            borderRadius: "12px",
            backgroundColor: theme.palette.grey[0]
        },
        children: /*#__PURE__*/ _jsx(Typography, {
            variant: "body1",
            color: "text.secondary",
            children: text
        })
    });
};
export default EmptyArea;
